import { Form, Col, Row} from 'react-bootstrap';
import {useEffect, useReducer, useState, useRef } from "react";

const DatatableDropdownCheckboxesField = ({label, handleChange, values, idKey, textKey, filter, filterKey, defaultItem, unique, dispatch}) => {
    const handleKeyPress = (e) => {
        //console.log("KEYPRESS");
        //console.log(e.nativeEvent);
        if(e.nativeEvent.code === 'Enter'){
            e.preventDefault();
        }
    }

   
    //console.log(filter);

    return (
        
            <Col className="d-flex align-items-center fit-content">
                    <Form.Group as={Col} className="col-auto" >
                        <fieldset className="d-flex align-items-center flex-fit">
                            
                            <legend className="datatable-filter-label flex-lg-shrink-0 form-label">
                                {<span className="me-2 ">{label}</span>}
                            </legend>
                            {
                                values.map((v,index) => 
                               
                                    <Form.Check
                                        key={"chkDropdown" + (idKey==null ? index : v[idKey])}
                                        type="checkbox"
                                        //title={v.title}
                                        label={ 
                                            textKey==null ? v : v[textKey]
                                        }
                                        name={"chkDropdown" + (idKey==null ? index : v[idKey])}
                                        id={"chkDropdown" + (idKey==null ? index : v[idKey]) + unique}
                                        value={idKey==null ? v : v[idKey]}
                                        onChange={handleChange}
                                        className={"ms-0 mt-2 mb-2 me-2 fit-content"}
                                        checked={filter[filterKey]==v[idKey]? true : false}
                                        //isInvalid={q.answers[index].isInvalid}
                                        //isValid={q.answers[index].isValid}
                                        //disabled={pageType=="VIEW" ? true : false}
                                    ></Form.Check>
                                
                                )
                            }
                        </fieldset>
                    </Form.Group>
                
            </Col>
        
    )
}

export default DatatableDropdownCheckboxesField;